<template>
    <item-create-view v-slot:default="_">
        <assignment-edit-form
                :disabled="_.itemDisabled"
                v-model="_.item"
        />
    </item-create-view>
</template>

<script>
    import ItemCreateView from '../../Item/Views/ItemCreateView'
    import AssignmentEditForm from './Shared/AssignmentEditForm'

    export default {
        name: 'AssignmentsCreatePage',
        components: {
            ItemCreateView,
            AssignmentEditForm,
        },
    }
</script>
